@let fetchedAt = $userBatchesFetchedAt | async; @let userBatches = $userBatches
| async;

<div
  style="display: flex; padding: 16px; position: relative; margin-bottom: 32px"
>
  <button
    (click)="onUserBatchUploadClicked()"
    mat-raised-button
    color="primary"
    type="button"
    class="px-4"
    style="position: absolute; right: 0px"
  >
    Add Batch Upload
    <mat-icon>upload</mat-icon>
  </button>
  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    accept=".xlsx, .xls"
    style="display: none"
    (change)="onFileSelected($event)"
  />
</div>

@if (fetchedAt && userBatches?.length) {
<div class="table-container">
  <table mat-table [dataSource]="userBatches ?? []" class="responsive-table">
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>File Name</th>
      <td mat-cell *matCellDef="let element">
        {{ element.fileName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalRecords">
      <th mat-header-cell *matHeaderCellDef>Total Records</th>
      <td mat-cell *matCellDef="let element">{{ element.totalRecords }}</td>
    </ng-container>

    <ng-container matColumnDef="processedCount">
      <th mat-header-cell *matHeaderCellDef>Processed Count</th>
      <td mat-cell *matCellDef="let element">
        {{ element.processedCount }}
      </td>
    </ng-container>

    <ng-container matColumnDef="failedCount">
      <th mat-header-cell *matHeaderCellDef>Failed Count</th>
      <td mat-cell *matCellDef="let element">
        {{ element.failedCount }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <div class="centered-vertically">
          <mat-icon
            class="{{ utils.getBatchUploadStatusColor(element.status) }}"
          >
            {{ utils.getBatchUploadStatusIcon(element.status) }}
          </mat-icon>
          <span class="small-light-grey">
            {{ element.status }}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex justify-content-between align-items-center">
          @if (element.status === 'failed' && element.validationReportFileUrl) {
          <mat-icon
            matTooltip="View Report"
            class="clickable pointer"
            (click)="downloadFile(element.validationReportFileUrl)"
          >
            download
          </mat-icon>
          } @if (element.status === 'validated') {

          <mat-icon
            matTooltip="Publish"
            class="clickable pointer material-symbols-outlined"
            (click)="processBatchUpload(element.id)"
          >
            publish
          </mat-icon>
          } @if (element.status === 'complete') {
          <mat-icon
            matTooltip="View"
            class="clickable pointer material-symbols-outlined"
            (click)="downloadFile(element.finalReportFileUrl)"
          >
            visibility
          </mat-icon>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>
} @if (fetchedAt && !userBatches?.length) {
<div class="text-center">
  <p>No User Batch Uploads</p>
</div>
} @if (!fetchedAt) {
<div class="d-flex justify-content-center mt-4">
  <mat-spinner diameter="30"></mat-spinner>
</div>
}
